<script setup lang="ts">
import { onMounted, ref } from 'vue';

const mounted = ref(false);

onMounted(() => {
  mounted.value = true;
});
</script>

<template>
  <slot v-if="mounted"></slot>
  <slot v-else name="fallback"></slot>
</template>
